<template>
  <div
    class="lib-common-model-scroll"
    ref="lib-common-model-scroll"
    @touchstart="touchstart"
    @touchmove="touchmove"
    @scroll="scroll"
  >
    <slot />
  </div>
</template>

<script>
// 弹窗滚动区域，用于除了body之外的滚动嵌套，可以阻止（不支持pc）滚动的时候滚到父级
module.exports = {
  props: {
    // 是否阻止水平方向
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scroll(e) {
      const $el = this.$refs['lib-common-model-scroll']
      this.$emit('scroll', $el, e)
    },
    touchstart(e) {
      this.startX = e.changedTouches[0].pageX
      this.startY = e.changedTouches[0].pageY
    },
    touchmove(e) {
      e.stopPropagation()
      var deltaX = e.changedTouches[0].pageX - this.startX
      var deltaY = e.changedTouches[0].pageY - this.startY
      const $el = this.$refs['lib-common-model-scroll']
      if (Math.abs(deltaY) < Math.abs(deltaX)) {
        if (this.horizontal) {
          if ($el.offsetWidth + $el.scrollLeft >= $el.scrollWidth) {
            if (deltaX < 0) {
              e.preventDefault()
              return false
            }
          }
          if ($el.scrollLeft === 0) {
            if (deltaX > 0) {
              e.preventDefault()
              return false
            }
          }
        }
      } else {
        if ($el.offsetHeight + $el.scrollTop >= $el.scrollHeight) {
          if (deltaY < 0) {
            e.preventDefault()
            return false
          }
        }
        if ($el.scrollTop === 0) {
          if (deltaY > 0) {
            e.preventDefault()
            return false
          }
        }
      }
    }
  }
}
</script>
